// src/lib/contact.js
// Single source of truth for customer-facing contact details. Values come from
// build-time config (Vite env) with the current numbers as defaults, so they can
// be changed without code edits (the WhatsApp number is TBC by Robert). Do NOT
// hardcode these inline in components — import from here.
export const LANDLINE = import.meta.env.VITE_LANDLINE || '0161 317 8556';
export const LANDLINE_TEL = LANDLINE.replace(/\s/g, '');
export const WHATSAPP_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER || '447446166043'; // wa.me form: no +, no leading 0
export const WHATSAPP_DISPLAY = import.meta.env.VITE_WHATSAPP_DISPLAY || '+44 (0) 744 616 6043';
export const WHATSAPP_TEL = import.meta.env.VITE_WHATSAPP_TEL || '+447446166043'; // E.164 tel: form
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'info@taxstats.co.uk';
